import React from 'react';

export default function PipButton (props) {

  const handleClickPipClose = (e) => {
    e.preventDefault();
    props.onClick();
  };

  return (
    <button type="button" className="btn_pip_closed" style={{ display: (props.view ? 'block' : 'none') }} onClick={handleClickPipClose.bind(this)}>
      <span className="icon_pip_closed">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
          <path d="M12.17,1.271.521,1.434A.572.572,0,0,1,0,.806H0A.612.612,0,0,1,.538.163L12.188,0a.572.572,0,0,1,.521.628h0A.612.612,0,0,1,12.17,1.271Z" transform="translate(1.014 0) rotate(45)"></path>
          <path d="M12.17.163.521,0A.572.572,0,0,0,0,.628H0a.612.612,0,0,0,.538.643l11.649.163a.572.572,0,0,0,.521-.628h0A.612.612,0,0,0,12.17.163Z" transform="translate(10 1.014) rotate(135)"></path>
        </svg>
      </span>
    </button>
  );
}
